'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _clickOutside = require('click-outside');

var _clickOutside2 = _interopRequireDefault(_clickOutside);

var _deepEqual = require('deep-equal');

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _lodash = require('lodash.last');

var _lodash2 = _interopRequireDefault(_lodash);

var _uniq = require('uniq');

var _uniq2 = _interopRequireDefault(_uniq);

var _option = require('./option');

var _option2 = _interopRequireDefault(_option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /** @jsx dom */


var propTypes = {
	class: {
		type: 'string'
	},
	forceClose: {
		type: 'boolean'
	},
	id: {
		type: 'string'
	},
	multiple: {
		type: 'boolean'
	},
	name: {
		type: 'string'
	},
	onChange: {
		type: 'function'
	},
	options: {
		type: 'array'
	},
	placeholder: {
		type: 'string'
	},
	required: {
		type: 'boolean'
	},
	symbol: {
		type: 'string'
	},
	showValue: {
		type: 'boolean'
	},
	toggle: {
		type: 'boolean'
	}
};

var stateWillBeValid = function stateWillBeValid(_ref, _ref2) {
	var required = _ref.required;
	var active = _ref2.active;
	return !required || active.length > 0;
};

var defaultProps = {
	options: [],
	showValue: true,
	symbol: '\u2A2F'
};

var initialState = function initialState(_ref3) {
	var options = _ref3.options;
	return {
		active: options.filter(function (option) {
			return option.active;
		})
	};
};

var afterMount = function afterMount(_ref4, el, setState) {
	var props = _ref4.props,
	    state = _ref4.state;
	var multiple = props.multiple,
	    options = props.options;
	var active = state.active;

	var activeWithActiveOptions = active.concat(options.filter(function (option) {
		return option.active;
	}));
	var usableActives = multiple || active.length < 1 ? active : [(0, _lodash2.default)(activeWithActiveOptions)];

	(0, _clickOutside2.default)(el, function () {
		return setState({ open: false });
	});

	if (stateWillBeValid(props, { active: usableActives })) {
		setState({ active: usableActives });
	}
};

var onRemove = function onRemove(val, props, state, setState) {
	var name = props.name,
	    onChange = props.onChange;
	var active = state.active;

	var newActive = active.filter(function (x) {
		return x.value !== val;
	});

	if (!stateWillBeValid(props, { active: newActive })) {
		return;
	}

	setState({ active: active });

	if (onChange) {
		onChange(_defineProperty({}, name, (0, _uniq2.default)(active.map(function (x) {
			return x.value;
		}), function (a, b) {
			return !(0, _deepEqual2.default)(a, b);
		})));
	}
};

var getText = function getText(props, state, setState) {
	var multiple = props.multiple,
	    placeholder = props.placeholder,
	    showValue = props.showValue,
	    symbol = props.symbol;
	var active = state.active;


	if (active.length > 0 && multiple && showValue) {
		return active.map(function (x) {
			return (0, _magicVirtualElement2.default)(
				'div',
				{ 'class': 'Select-multiple' },
				(0, _magicVirtualElement2.default)(
					'div',
					{ 'class': 'Select-remove', onClick: function onClick() {
							return onRemove(x.value, props, state, setState);
						} },
					symbol
				),
				x.label
			);
		});
	}

	if (active.length > 0 && !multiple && showValue) {
		return (0, _magicVirtualElement2.default)(
			'div',
			{ 'class': 'Select-text' },
			active[0].label
		);
	}

	return (0, _magicVirtualElement2.default)(
		'div',
		{ 'class': 'Select-placeholder' },
		placeholder
	);
};

var changeOrAppend = function changeOrAppend(item, items, allowMultiple) {
	return allowMultiple ? items.concat([item]) : [item];
};
var removeOrAdd = function removeOrAdd(item, items, allowMultiple, remove) {
	if (remove) {
		return items.filter(function (x) {
			return x.value !== item.value;
		});
	}

	var withAdded = changeOrAppend(item, items, allowMultiple);
	return (0, _uniq2.default)(withAdded, function (a, b) {
		return !(0, _deepEqual2.default)(a, b);
	});
};

var _onClick = function _onClick(clickedOption, props, state, setState) {
	var forceClose = props.forceClose,
	    multiple = props.multiple,
	    name = props.name,
	    onChange = props.onChange;
	var active = state.active,
	    open = state.open;

	var clickedOnActive = active.some(function (option) {
		return (0, _deepEqual2.default)(option.value, clickedOption.value);
	});
	var newActives = removeOrAdd(clickedOption, active, multiple, clickedOnActive);
	var openStatus = multiple && !forceClose ? open : false;

	if (!stateWillBeValid(props, { active: newActives })) {
		setState({ open: openStatus });
		return;
	}

	setState({
		active: newActives,
		open: openStatus
	});

	if (onChange) {
		onChange(_defineProperty({}, name, (0, _uniq2.default)(newActives.map(function (x) {
			return x.value;
		}), function (a, b) {
			return !(0, _deepEqual2.default)(a, b);
		})));
	}
};

var openSelect = function openSelect(_ref5, setState) {
	var open = _ref5.open,
	    toggle = _ref5.toggle;
	return function () {
		return setState({ open: toggle === true ? !open : true });
	};
};

var renderOptions = function renderOptions(props, state, setState) {
	var options = props.options,
	    styleClasses = props.styleClasses;
	var active = state.active;

	var actives = active.filter(function (x) {
		return x.value;
	}).map(function (x) {
		return x.value;
	});

	return options.map(function (option) {
		return (0, _magicVirtualElement2.default)(_option2.default, { styleClasses: styleClasses, active: actives.some(function (y) {
				return (0, _deepEqual2.default)(y, option.value);
			}), data: option, onClick: function onClick() {
				return _onClick(option, props, state, setState);
			} });
	});
};

var afterUpdate = function afterUpdate(_ref6, prevProps, prevState, setState) {
	var props = _ref6.props,
	    state = _ref6.state;

	if (!(0, _deepEqual2.default)(props.options.map(function (option) {
		return option.value;
	}), prevProps.options.map(function (option) {
		return option.value;
	}))) {
		setState(initialState(defaultProps));
	}
};

var render = function render(_ref7, setState) {
	var props = _ref7.props,
	    state = _ref7.state;
	var id = props.id,
	    toggle = props.toggle,
	    styleClasses = props.styleClasses;
	var open = state.open;


	return (0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['Select', props.class], id: id },
		(0, _magicVirtualElement2.default)(
			'div',
			{ 'class': [!styleClasses || styleClasses && !styleClasses.Select && 'Select-input', styleClasses && styleClasses.Select], 'data-style-attr': 'Select', onClick: openSelect({ open: open, toggle: toggle }, setState) },
			getText(props, state, setState)
		),
		(0, _magicVirtualElement2.default)(
			'div',
			{ 'class': [!styleClasses || styleClasses && !styleClasses.Options && 'Select-options', { 'Select-options--open': open }, styleClasses && styleClasses.Options], 'data-style-attr': 'Options' },
			renderOptions(props, state, setState)
		)
	);
};

exports.default = { afterMount: afterMount, afterUpdate: afterUpdate, defaultProps: defaultProps, initialState: initialState, propTypes: propTypes, render: render };